import { Button, Modal } from '@/components';
import { cn } from '@/utils';
import { memo, useCallback, useState } from 'react';
import SignatureCanvas, {
	ReactSignatureCanvasProps,
} from 'react-signature-canvas';

import { ModalProps } from 'antd';

type SignatureModalProps = ModalProps & {
	open: boolean;
	onCancel: () => void;
	onSubmit: () => void;
	refCanvas: React.RefObject<SignatureCanvas>;
	signatureCanvasProps?: ReactSignatureCanvasProps;
};

const ModalSignature = ({
	open,
	onCancel,
	onSubmit,
	refCanvas,
	signatureCanvasProps = {},
	...rest
}: SignatureModalProps) => {
	const [isSignature, setIsSignature] = useState(false);
	const [errorSign, setErrorSign] = useState(false);

	const handleSubmit = useCallback(() => {
		if (isSignature) {
			onSubmit();
			setErrorSign(false);
		} else {
			setErrorSign(true);
		}
		setIsSignature(false);
		refCanvas.current?.clear();
	}, [isSignature]);

	const handleClose = useCallback(() => {
		setIsSignature(false);
		setErrorSign(false);
		onCancel();
		refCanvas.current?.clear();
	}, []);

	return (
		<Modal
			destroyOnClose
			open={open}
			onCancel={onCancel}
			title="서명 패드"
			{...rest}
			className="!w-[520px]"
		>
			<SignatureCanvas
				canvasProps={{
					className: cn(
						'w-full h-[200px] border-solid border border-black',
						errorSign && 'border-2 border-red5'
					),
					width: 462,
					height: 200,
				}}
				ref={refCanvas}
				onBegin={() => {
					setIsSignature(true);
				}}
				minWidth={2}
				maxWidth={4}
				{...signatureCanvasProps}
			/>

			<div className="flex w-full mt-8 gap-2">
				<Button ghost type="primary" className="flex-1" onClick={handleClose}>
					취소
				</Button>
				<Button type="primary" className="flex-1" onClick={handleSubmit}>
					저장
				</Button>
			</div>
		</Modal>
	);
};

export default memo(ModalSignature);
